"use strict";
/*
* Created on 23.05.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Domain object of exact distribution of sales area.
 * Object contains the individual product categories and their properties within one store and one product.
 * @author ZSr
 */


var ProductPlacement =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(ProductPlacement, _StateDomainObject_1$);

  /**
   * @param id internal id
   * @param externalId
   * @param siteId identification of sites
   * @param promotionId internal id of a promotion
   * @param productId internal od of a product
   * @param validFrom
   * @param validTo
   * @param placementTypeId
   * @param stateFlags
   */
  function ProductPlacement(id, externalId, siteId, promotionId, productId, validFrom, validTo, placementTypeId, stateFlags) {
    var _this;

    _classCallCheck(this, ProductPlacement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPlacement).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.siteId = siteId;
    _this.promotionId = promotionId;
    _this.productId = productId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.placementTypeId = placementTypeId;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return ProductPlacement;
}(StateDomainObject_1.StateDomainObject);

exports.ProductPlacement = ProductPlacement;

ProductPlacement.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductPlacement.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    siteId: builder.str('siteId'),
    promotionId: builder.opt(builder.str('promotionId')),
    productId: builder.str('productId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.opt(builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)),
    placementTypeId: builder.lookup('placementTypeId', CodebookLookupSequence_1.CodebookLookupSequence.PlacementTypes),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();